import React from "react"
import { AdministrationOptions } from "components/UserManagement/interfaces"
import FormUsers from "../Forms/Users"
import { putUser } from "components/UserManagement/service"

interface EditProps {
	component: React.ReactElement
	endpoint: (value: any) => Promise<any>
}

export const disabledList = { email: true }

export const EditComponents: Record<AdministrationOptions, EditProps> = {
	users: {
		component: <FormUsers />,
		endpoint: putUser,
	},
	organizations: {
		component: <></>,
		endpoint: (value) => value,
	},
}
